diy.angular.registerDirective('diyfmtoolbarselectall', ['diyl10n', 'diyfmselectiondata', 'diyfmmessages', 'diyfmsectionsdata', 'diyfmblocking',
function(diyl10n, diyfmselectiondata, diyfmmessages, diyfmsectionsdata, diyfmblocking) {
    var $ = jQuery;
    var selectAllCounter = 1;
    
    var tpl = '\
        <input type="checkbox" class="fm-toolbar-select"\
            /><label class="ui-button-borderless fm-toolbar-select-label"></label>\
    ';

    return {
        template: tpl,
        restrict: 'A',
        scope: true,
        link: function(scope, elem, attr) {
            
            var 
                $elem = $(elem),
                allSelected = false, 
                selectElId = 'fm-toolbar-select-' + (selectAllCounter++),
                selectBtn = $elem.find('.fm-toolbar-select')
            ;
            
            var toggleSelectAll = function() {
                allSelected = !allSelected;
                
                if (allSelected) {
                    var unblock = diyfmblocking.block(diyl10n('filemanager.selectInProgress'));
                    $elem.find('.fm-toolbar-select-label .ui-icon').addClass('ui-icon-loading');
                    diyfmsectionsdata.getCurrentSubsection().getOrLoadAllItems().then(function(items){
                        diyfmselectiondata.setSelectionItems(items);
                    }).finally(function(){
                        $elem.find('.fm-toolbar-select-label .ui-icon').removeClass('ui-icon-loading');
                        unblock();    
                    });
                } else {
                    diyfmselectiondata.setSelectionItems([]);
                }
            };
                
            
            $elem.find('.fm-toolbar-select-label').attr('for', selectElId);
            selectBtn
                .attr('id', selectElId)
                .button({
                    icons: {primary: 'ui-icon-1and1-select'},
                    label: diyl10n('filemanager.selectAll'),
                    text: false
                })
                .click(function() {
                    toggleSelectAll();
                    scope.$apply();
                });
            
            var refreshSelectButton = function() {
                var label;
                
                if (allSelected) {
                    label = diyl10n('filemanager.deselectAll');
                } else {
                    label = diyl10n('filemanager.selectAll');
                }
                selectBtn.button('option', 'label', label);
                selectBtn.prop('checked', !!allSelected).button("refresh");
            };
            
            scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(){
                var allItems = diyfmsectionsdata.getCurrentSubsection().getItems();
                var selCount = diyfmselectiondata.getSelectedItems().length;
                if (typeof allItems !== 'undefined') {
                    allSelected = (selCount === allItems.length && selCount > 0);
                } else {
                    allSelected = false;
                }
                refreshSelectButton();
            });

            scope.$watch(function() {
                var items = diyfmsectionsdata.getCurrentSubsection().getItems();
                if (items !== undefined) {
                    return items.length;
                } else {
                    return 0;
                }
            } , function(newLength){
                if (newLength > 0) {
                    selectDisabled = false;
                } else {
                    selectDisabled = true;
                }
                selectBtn.button('option', 'disabled', selectDisabled);
            });
        }
    };
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmtoolbarselectall.js
 ** module id = 968
 ** module chunks = 0
 **/